import React, { Component } from 'react';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import Layout from './Layout/Layout';
import Pendentes from './Componente/Pendentes/Pendentes';
import Emitidas from './Componente/Emitidas/Emitidas';
import Rejeitadas from './Componente/Rejeitadas/Rejeitadas';
import Empresas from './Componente/Empresas/Empresas';
import Erro from './Componente/Common/Erro';
import ValidarLogin from './Componente/ValidarLogin/ValidarLogin';
import SimularAcesso from './Componente/SimularAcesso/SimularAcesso';
import AlertasProvider from './Providers/Alertas';
import BlockUiProvider from './Providers/BlockUi';
import WhitePage from './Layout/WhitePage';
import ModalToken from './Componente/ValidarLoginToken/ModalToken';

class Routes extends Component {
	render() {
		return (
			<BrowserRouter>
				<AlertasProvider>
					<BlockUiProvider>
						<Switch>
							<Route exact path="/">
								<Layout params="">
									<Pendentes />
								</Layout>
							</Route>
							<Route exact path="/pendentes">
								<Layout params="">
									<Pendentes />
								</Layout>
							</Route>
							<Route exact path="/emitidas">
								<Layout params="">
									<Emitidas />
								</Layout>
							</Route>
							<Route exact path="/rejeitadas">
								<Layout params="">
									<Rejeitadas />
								</Layout>
							</Route>
							<Route exact path="/empresas">
								<Layout params="">
									<Empresas />
								</Layout>
							</Route>
							<Route exact path="/simular-acesso">
								<Layout params="">
									<SimularAcesso />
								</Layout>
							</Route>
							<Route exact path="/feedback">
								<Layout params="">
									<Pendentes />
								</Layout>
							</Route>
							<Route
								exact
								path="/validar-login/:idUsuario"
								render={({ match }) => <ValidarLogin params={match.params} />}
							/>
							<Route
								exact
								path="/validar-login"
								render={({ match }) => <ValidarLogin/>}
							/>
							<Route
								exact
								path="/validar-login/:idUsuario/:simular"
								render={({ match }) => <ValidarLogin params={match.params} />}
							/>
							<Route
								exact
								path="/validar-token"
								render={() => (
									<WhitePage>
										<ModalToken />
									</WhitePage>
								)}
							/>
							<Route exact path="/erro/:idErro" render={({ match }) => <Erro params={match.params} />} />
							<Route path="*" render={() => <Redirect to="/erro/404" />} />
						</Switch>
					</BlockUiProvider>
				</AlertasProvider>
			</BrowserRouter>
		);
	}
}

export default Routes;
